import { Injectable } from '@angular/core';
import { createRequestOption } from '../app/shared/util/request-util';
import { getSpecialPlaceIdentifier, ISpecialPlace } from '../models/special-place.model';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { isPresent } from './operators';
import { ApplicationConfigService } from './application-config.service';
import { Observable } from 'rxjs';

export type EntityResponseType = HttpResponse<ISpecialPlace>;
export type EntityArrayResponseType = HttpResponse<ISpecialPlace[]>;

@Injectable({ providedIn: 'root' })
export class SpecialPlaceService {
  protected resourceUrl: string;

  constructor(protected http: HttpClient, protected applicationConfigService: ApplicationConfigService) {
    this.resourceUrl = this.applicationConfigService.getEndpointFor('api/special-places');
  }

  create(specialPlace: ISpecialPlace): Observable<EntityResponseType> {
    return this.http.post<ISpecialPlace>(this.resourceUrl, specialPlace, { observe: 'response' });
  }

  update(specialPlace: ISpecialPlace): Observable<EntityResponseType> {
    return this.http.put<ISpecialPlace>(`${this.resourceUrl}/${getSpecialPlaceIdentifier(specialPlace)}`, specialPlace, {
      observe: 'response',
    });
  }

  partialUpdate(specialPlace: ISpecialPlace): Observable<EntityResponseType> {
    return this.http.patch<ISpecialPlace>(`${this.resourceUrl}/${getSpecialPlaceIdentifier(specialPlace)}`, specialPlace, {
      observe: 'response',
    });
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<ISpecialPlace>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ISpecialPlace[]>(this.resourceUrl, { params: options, observe: 'response' });
  }

  delete(id: number): Observable<HttpResponse<{}>> {
    return this.http.delete(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  addSpecialPlaceToCollectionIfMissing(specialPlaceCollection: ISpecialPlace[], ...specialPlacesToCheck: (ISpecialPlace | null | undefined)[]): ISpecialPlace[] {
    const specialPlaces: ISpecialPlace[] = specialPlacesToCheck.filter(isPresent);
    if (specialPlaces.length > 0) {
      const specialPlaceCollectionIdentifiers = specialPlaceCollection.map(specialPlaceItem => getSpecialPlaceIdentifier(specialPlaceItem));
      const specialPlacesToAdd = specialPlaces.filter(specialPlaceItem => {
        const specialPlaceIdentifier = getSpecialPlaceIdentifier(specialPlaceItem);
        if (specialPlaceIdentifier == null || specialPlaceCollectionIdentifiers.includes(specialPlaceIdentifier)) {
          return false;
        }
        specialPlaceCollectionIdentifiers.push(specialPlaceIdentifier);
        return true;
      });
      return [...specialPlacesToAdd, ...specialPlaceCollection];
    }
    return specialPlaceCollection;
  }
}
